export const APP_COLORS = {
    background:'#bfbfbf',
    button: '#191919',
    text: '#323232',
    textbutton:'#e5e5e5',
    link:'#4c4cff',
    withe:'#F8F8FF'
};